import { defineComponent, computed, useFetch, } from '@nuxtjs/composition-api';
import { HaveAQuestion, InstallVideo } from '~/modules/b2b/components/beast';
import { HaveAQuestionDefaults, IntallIstructionsAntiFog } from '~/composables/useContentful/defaults';
import { useContentful } from '~/composables';
import { useB2BUiState, useVideoUrls } from '~/modules/b2b/composables';
export default defineComponent({
    name: 'BeastInstallAntiFog',
    components: { HaveAQuestion, InstallVideo },
    layout: 'clean',
    setup() {
        const { search, content } = useContentful('install-instructions-anti-fog-goose');
        const { goTo } = useB2BUiState();
        const { antiFogVideoUrl } = useVideoUrls();
        useFetch(async () => {
            await search({
                url: 'install-instructions-anti-fog-goose',
            });
        });
        const HaveAQuestionProps = computed(() => {
            var _a, _b, _c, _d;
            return ((_d = (_c = (_b = (_a = content.value[0]) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.find((item) => item.fields.id === 'have-a-question')) === null || _d === void 0 ? void 0 : _d.fields) || HaveAQuestionDefaults;
        });
        const title = computed(() => { var _a, _b; return ((_b = (_a = content.value[0]) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.title) || 'Anti-fog instructions'; });
        const Instructions = computed(() => {
            var _a, _b, _c, _d;
            return ((_d = (_c = (_b = (_a = content.value[0]) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.find((item) => item.fields.id === 'install-instructions-anti-fog-goose')) === null || _d === void 0 ? void 0 : _d.fields) || IntallIstructionsAntiFog;
        });
        return {
            HaveAQuestionProps,
            title,
            Instructions,
            goTo,
            antiFogVideoUrl,
        };
    },
    head() {
        return {
            title: this.title,
        };
    },
});
